module.exports = __webpack_public_path__ + "static/logo-303590f51187b23fa0a5b95edc495511.png";